// Ориентация экрана — ОДИН источник правды для меты: и раскладка (CSS через
// data-orient), и логика (пагинация карты по половинам участка) читают этот
// хук. Своя `@media (orientation: portrait)` в CSS была бы вторым источником:
// в момент поворота React и стили могли бы разойтись на кадр.
//
// jsdom не реализует matchMedia (тот же случай, что reduceMotion в MapScreen) —
// без него считаем альбом, поэтому юнит-тесты идут по альбомной ветке.

import { useEffect, useState } from 'react';

const PORTRAIT = '(orientation: portrait)';

function matchPortrait(): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia(PORTRAIT).matches;
}

export function usePortrait(): boolean {
  const [portrait, setPortrait] = useState(matchPortrait);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(PORTRAIT);
    const sync = () => setPortrait(mq.matches);
    sync(); // ориентация могла смениться между первым рендером и эффектом
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return portrait;
}
